var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLenovo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.4 66.5",
    style: {
      enableBackground: "new 0 0 200.4 66.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.lenovo-0{fill:#8C98A4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "n_1_",
    className: "lenovo-0",
    d: "M80.4,21.2c-3.5,0-7.4,1.6-9.8,4.8l0,0l0,0v-4.3h-8.2v30h8.2V34.6c0-3.1,2.4-6.3,6.8-6.3 c3.4,0,6.9,2.4,6.9,6.3v17.1h8.2V33.1C92.6,26.2,87.7,21.2,80.4,21.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "v",
    className: "lenovo-0",
    points: "151.2,21.7 143.8,42.1 136.3,21.7 126.9,21.7 139.3,51.7 148.3,51.7 160.6,21.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "e_1_",
    className: "lenovo-0",
    d: "M55.8,26.1c-2.8-3.2-6.9-4.9-11.9-4.9c-9.1,0-15.9,6.7-15.9,15.5c0,9.1,6.9,15.5,16.8,15.5 c5.6,0,11.3-2.6,14-5.7l-5.2-4c-3.4,2.5-5.4,3.2-8.6,3.2c-2.8,0-5.1-0.9-6.6-2.4l21.1-8.7C59,31.2,57.7,28.3,55.8,26.1z M36.1,37.9 c-0.4-3.1,0.4-5.5,1.7-7.2c1.4-1.9,3.6-3,6.3-3c3,0,5.2,1.7,6.4,4.2L36.1,37.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "l_1_",
    className: "lenovo-0",
    points: "8.6,12.7 0.2,12.7 0.2,51.7 27.3,51.7 27.3,44.1 8.6,44.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "o_4_",
    className: "lenovo-0",
    d: "M175.6,21.2c-9.1,0-16.2,6.8-16.2,15.5c0,8.8,7.1,15.5,16.1,15.5c9.1,0,16.2-6.8,16.2-15.5 C191.6,27.9,184.6,21.2,175.6,21.2z M175.6,45.1c-4.5,0-8.1-3.7-8.1-8.5c0-5,3.3-8.5,7.9-8.5c4.5,0,8.1,3.7,8.1,8.5 C183.5,41.6,180.2,45.1,175.6,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o_3_",
    className: "lenovo-0",
    d: "M112.1,21.2c-9.1,0-16.2,6.8-16.2,15.5c0,8.8,7.1,15.5,16.1,15.5c9.1,0,16.2-6.8,16.2-15.5 C128.2,27.9,121.1,21.2,112.1,21.2z M112.1,45.1c-4.5,0-8.1-3.7-8.1-8.5c0-5,3.3-8.5,7.9-8.5c4.5,0,8.1,3.7,8.1,8.5 C120,41.6,116.7,45.1,112.1,45.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "t",
    className: "lenovo-0",
    points: "191.4,48.1 192.8,48.1 192.8,51.7 193.6,51.7 193.6,48.1 194.9,48.1 194.9,47.4 191.4,47.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "m_1_",
    className: "lenovo-0",
    points: "199.3,47.4 198,49.4 196.7,47.4 195.8,47.4 195.8,51.7 196.6,51.7 196.6,48.6 198,50.7 198.1,50.7 199.4,48.6 199.4,51.7 200.2,51.7 200.2,47.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLenovo);
export default __webpack_public_path__ + "static/media/lenovo.b0f22f8b71ec4c51e6a8e2b10a85b998.svg";
export { ForwardRef as ReactComponent };